// extracted by mini-css-extract-plugin
export default {"root":"Select_root__ceNQR","chevron":"Select_chevron__5m73K"};